/* Home — Meet Dozzee: words light up as you scroll; the "softer way" highlight wipes in. */
(function () {
  function Meet(sec) {
    var D = window.Dozzee || {}, ctx = null, splits = [], alive = true;
    if (!D.reduce && D.gsap) D.gsap(function (gsap, ST, Split) {
      if (!alive) return;
      ctx = gsap.context(function () {
        Array.prototype.slice.call(sec.querySelectorAll('[data-words]')).forEach(function (el) {
          var sp = Split.create(el, { type: 'words', tag: 'span' }); splits.push(sp);
          gsap.fromTo(sp.words, { opacity: 0.14 }, { opacity: 1, stagger: 0.1, ease: 'none', scrollTrigger: { trigger: el, start: 'top 78%', end: 'bottom 45%', scrub: true } });
        });
        var hl = sec.querySelector('[data-hl-bg]');
        if (hl) gsap.fromTo(hl, { scaleX: 0 }, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: hl.parentElement, start: 'top 64%', end: 'top 50%', scrub: true } });
      }, sec);
    });
    this.destroy = function () {
      alive = false;
      if (ctx) ctx.revert();
      splits.forEach(function (s) { try { s.revert(); } catch (e) {} });
    };
  }
  function init(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-section-type="home-meet"]')).forEach(function (sec) {
      if (!sec._hmMeet) sec._hmMeet = new Meet(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.slice.call(e.target.querySelectorAll('[data-section-type="home-meet"]')).forEach(function (sec) {
      if (sec._hmMeet) { sec._hmMeet.destroy(); sec._hmMeet = null; }
    });
  });
})();
